module.exports = __webpack_public_path__ + "static/img/A1.d345fc89.png";